export default{
  basic_information: 'Basic Information',
  main_products: 'Main Products',
  factory_area:'Factory Area',
  certifications: 'Certifications',
  inspections: 'Inspections',
  manufacturing_process: 'Manufacturing Process',
  quality_management: 'Quality Management',
  base: {
    factory_name: 'Factory Name',
    factory_address: 'Factory address',
    fPS_coordinates_at_main_entry: 'GPS coordinates at main entry',
    established_date: 'Established Date',
    audit_date: 'Audit Date',
    auditor: 'Auditor',
    number_of_r_d_engineers:'Number of R&D engineers',
    sample_lead_time:'Sample lead time (Days)',
    summary: 'Summary',
    main_customers:'Main Customers',
    customer_number: 'Number',
    customer_name: 'Name',
    customer_country: 'Country',
    customer_turnover: '% of Turnover'
  },
  products:{
    typology : 'Product Typology of the products',
    standard: 'Production Standard Lead Time (in days)',
    capacity: 'Monthly production capacity (in pieces)'
  },
  certifications_title:{
    certification: 'Certification / Approvals',
    regulatory: 'Regulatory Requirements',
    compliance: 'Compliance or not',
    remark: 'Remark',
    certifications: 'Certifications',
    additional_photos: 'Additional Photos',
    certifications_1:'Certifications'
  },
  process:{
    index: 'Index',
    manufacturing: 'Manufacturing process',
    machines: 'Machines (Item & number)',
    maximum: 'Maximum Daily Output',
    number: 'Number of Workers',
    remark: 'Remark'
  },
  view:{
    summary: 'Summary',
    contents: 'Contents',
    plan: 'Plan',
    fullscreen:'Fullscreen',
    report: 'Report',
    cover_title: 'Factory Assessment Report',
    overview: 'Overview',
    press: 'Press and Drag',
    building_number: 'Building number',
    processTitle: ''
  }
}